import styled, { css } from 'styled-components';

interface GridCellContainerProps {
  rowHeight: string;
  showIcon: boolean;
  editable: boolean;
}

export const GridCellContainer = styled.div<GridCellContainerProps>`
  ${({ rowHeight, showIcon, editable }) =>
    css`
      cursor: ${editable ? 'pointer' : 'default'};
      height: ${rowHeight}px;
      .react-datepicker__input-container svg {
        visibility: ${showIcon ? 'visible' : 'hidden'};
      }
    `}
  //The absolute positioning and 100% width is required, if not hovering over other regions of the cell will not show the pick list button
  width: 100%;
  display: flex;
  align-items: center;

  // TO control the style of date input
  .react-datepicker__input-container input {
    border: none;
    background-color: transparent;
    padding: 0;
    border-radius: 0;
    pointer-events: none;
  }
`;
